export function millisecondsToSeconds(milliseconds) {
    return (milliseconds / 1000);
}
export function secondsToHours(seconds) {
    return (seconds / 60 / 60);
}
export function millisecondsToHours(milliseconds) {
    return (milliseconds / 60 / 60 / 1000);
}
export function hoursToSeconds(hours) {
    return round(hours * 60 * 60);
}
export function eurosToCents(euros) {
    return round(euros * 100);
}
export function centsToEuros(cents) {
    return (cents / 100);
}
export function percentToFactor(percent) {
    return (percent / 100);
}
export function factorToPercent(factor) {
    return (factor * 100);
}
export function getRate(a, b) {
    return (b === 0 ? 0 : a / b);
}
export function multiplyWithRate(value, rate) {
    return (value * rate);
}
export function multiplyWithFactor(value, factor) {
    return (value * factor);
}
export function multiplyWithPercent(value, percent) {
    return (value * percentToFactor(percent));
}
export function add(first, second) {
    return ((first ?? 0) + (second ?? 0));
}
export function sum(...values) {
    return values.reduce((total, value) => total + value, 0);
}
export function subtract(first, ...values) {
    return (first - values.reduce((total, value) => total + value, 0));
}
export function round(value, decimals = 0) {
    const factor = Math.pow(10, decimals);
    return (Math.round(value * factor) / factor);
}
export function min(first, ...values) {
    return Math.min(first, ...values);
}
export function max(first, ...values) {
    return Math.max(first, ...values);
}
//# sourceMappingURL=units.js.map